import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { MdOutlineEmail } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import "./contact.css";

const Contact = () => {
  const [message, setMessage] = useState(false);
  const formRef = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(true);
    emailjs
      .sendForm(
        "service_w4iycbm",
        "template_ytkce1k",
        formRef.current,
        "SEIndp_v0G9qhHUe4"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <>
      <section id="contact">
        <h5>Get In Touch</h5>
        <h5>
          I do receive your messages and will respond asap if the valid email is
          provided :)
        </h5>
        <h2>Contact Me</h2>
        <div className="container contact__container">
          <div className="contact__options">
            <article className="contact__option">
              <MdOutlineEmail className="contact__option-icon" />
              <h4>Email</h4>
              <h5>sidansari20@gmail.com</h5>
              <a href="mailto:sidansari20@gmail.com">Send a message</a>
            </article>
            <article className="contact__option">
              <BsWhatsapp className="contact__option-icon" />
              <h4>What's App</h4>
              <h5>8527814365</h5>
              <a href="https://wa.me/+918527814365">Send a message</a>
            </article>
          </div>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Your Full Name"
              name="user_name"
              minLength="3"
              maxLength="21"
              required
            />
            <input
              type="text"
              placeholder="Your Email"
              name="user_email"
              minLength="12"
              pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
              required
            />
            <textarea
              placeholder="Your message"
              rows="7"
              name="message"
              minLength="7"
              maxLength="200"
              required
            ></textarea>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
            {message && <span>Thanks, I'll reply ASAP :)</span>}
          </form>
        </div>
      </section>
    </>
  );
};

export default Contact;
